import React from "react";
import { Row, Col, Container } from "react-bootstrap";

function Github() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <h1 className="project-heading" style={{ paddingBottom: "40px" }}>
        LeetCode <strong className="purple">Journey</strong>
      </h1>

      <Container>
        <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
          <Col md={12} style={{ textAlign: "center" }}>
            <img
              src="https://leetcard.jacoblin.cool/r-abhinaver?theme=dark&font=Ubuntu&ext=heatmap"
              alt="LeetCode Stats"
              className="leetcode-stats-img"
            />
          </Col>
        </Row>
      </Container>
    </Row>
  );
}

export default Github;
